import { IconStyled, IconStylesProps } from './IconStyles';

export const Close = ({ size = 'base', className = '', fill = 'currentColor' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <path d="M0.525285 7.45981C0.2346 7.16493 0.236383 6.69072 0.529278 6.39802L2.93333 3.99564L0.54581 1.60237C0.253473 1.30933 0.252058 0.835398 0.542639 0.540618C0.836368 0.242644 1.31655 0.240845 1.61251 0.536609L4 2.92257L6.38749 0.536609C6.68345 0.240845 7.16363 0.242644 7.45736 0.540618C7.74794 0.835399 7.74653 1.30933 7.45419 1.60237L5.06667 3.99564L7.47072 6.39803C7.76362 6.69072 7.7654 7.16493 7.47471 7.45981C7.18121 7.75755 6.70141 7.75936 6.40567 7.46385L4 5.05998L1.59433 7.46385C1.29859 7.75937 0.818785 7.75755 0.525285 7.45981Z" fill={fill} />
    </IconStyled>
);
